import { FormGroup } from 'shared-components';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { Button } from 'shared-components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { close } from '../modal/modalSlice';
import { useCreateUserMutation } from './users.api';
import { IEditingUser, Role } from '@topshots/core-models';
import { selectTokenPayload } from '../login/authSlice';
import { Types } from 'mongoose';
import { FormLayout } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';
import { CheckboxList } from 'shared-components';
import { Checkbox } from 'shared-components';

export const CreateUser = () => {
  const dispatch = useAppDispatch();
  const { accountId } = useAppSelector(selectTokenPayload)!;
  const [create] = useCreateUserMutation();
  const { handleSubmit, getFieldProps, errors, ...formik } = useFormik<
    Partial<IEditingUser>
  >({
    initialValues: {
      email: '',
      password: '',
      roles: [],
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      email: yup.string().email(),
      password: yup.string().required(),
    }),
    onSubmit: async (values) => {
      const { email, password, roles } = values;
      await create({
        email,
        password,
        accounts: [
          {
            account_id: accountId as Types.ObjectId,
            roles: roles as Role[],
          },
        ],
      });
      toast.success('User created!', {
        autoClose: 2000,
      });
      dispatch(close());
    },
  });

  const handleCheckboxChange = (item: Role) => {
    const { roles } = formik.values;
    if ((roles ?? []).includes(item)) {
      // Remove item if it's already selected
      formik.setFieldValue(
        'roles',
        (roles ?? []).filter((val) => val !== item)
      );
    } else {
      // Add item if it's not selected
      formik.setFieldValue('roles', [...(roles ?? []), item]);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <FormLayout>
        <FormGroup>
          <Label htmlFor="email">Email</Label>
          <Input
            // withIcon={<EnvelopeIcon height={22} width={22} />}
            {...getFieldProps('email')}
            type="email"
            id="email"
          />
          {errors.email && <span>{errors.email}</span>}
        </FormGroup>
        <FormGroup>
          <Label htmlFor="password">Password</Label>
          <Input
            // withIcon={<LockClosedIcon height={22} width={22} />}
            {...getFieldProps('password')}
            type="password"
            id="password"
          />
          {errors.password && <span>{errors.password}</span>}
        </FormGroup>
        <FormGroup>
          <CheckboxList label="Roles" direction="vertical">
            {Object.entries(Role).map(([title, role]) => (
              <Checkbox
                label={title}
                type="checkbox"
                id={`Role:${role}`}
                name="selectedItems"
                value={role}
                checked={formik.values?.roles?.includes(role)}
                onChange={() => handleCheckboxChange(role)}
              />
            ))}
          </CheckboxList>
        </FormGroup>
        <FormGroup>
          <Button type="submit">Create</Button>
        </FormGroup>
      </FormLayout>
    </form>
  );
};
